// extracted by mini-css-extract-plugin
export default {"container":"DataViewWrapper_container__HOQO3"};